module.exports = __webpack_public_path__ + "media/images/icons/outlined/right-025f4d04499e0a55f43f515caca0e905.svg";